import React from 'react';
import Flexbox from '../components/misc/Flexbox'; 
import {UISref} from 'ui-router-react'; 

const NewsBox = ({
	left,
	right,
	name,
	image:img,
	slug='',
	date,
	text,
	staticData
}) => {
	const { image,title,alt,image_tiny } = img;
	const { label_mehr } = staticData;
	let divStyle = {
			backgroundImage: 'url(' + image + ')',
			backgroundSize: 'cover',
			maxWidth: '100%',
	}
	return(
		<section className="article-list">
			{
			(left)?
			<Flexbox left={left} right={right} />
			:null
			}
			<UISref to="root.informationen.newsdetails" params={{item:slug}}>
				<a>
					<article className="article-item">
						{
						(image) ?
                        <div className="fixed-ht-img ratio-news">
                            <div title={title} className="img-wrapper" style={divStyle}>
                            </div>
						</div>
						: null
						}
                        <time dateTime={date}>{date}</time>
						<h1>{name}</h1>
						<p className="sm-txt">
							<span className="hide-mobile">{date} - </span>{text}
						</p>
						<span className="more-link">- {label_mehr}</span>
					</article>
				</a>
			</UISref>
		</section>
	)
}
export default NewsBox;




// WEBPACK FOOTER //
// ./src/components/NewsBox.js